import React from 'react';
import { Tooltip } from 'antd';
import { LastUsedApi } from '../../../../../types/account_configurations';
import { localDateString, localTimeString } from '../../../../utils/Utils';

interface ConfigurationLastUsedApiProps {
  lastUsedApi: LastUsedApi | null;
}

const ConfigurationLastUsedApi: React.FC<ConfigurationLastUsedApiProps> = ({ lastUsedApi }) => {
  if (!lastUsedApi) {
    return <span />;
  }

  return (
    <Tooltip title={lastUsedApi.api_call}>
      <span>
        {localDateString(lastUsedApi.last_used_at)} {localTimeString(lastUsedApi.last_used_at)}
      </span>
    </Tooltip>
  );
};

export default ConfigurationLastUsedApi;
